module.exports = __webpack_public_path__ + "files/3ea4cffdf67ebf2ad373fb96b903065d.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300italic.woff2
// module id = 1096
// module chunks = 60